import { getPatchedDataSchema } from '@tencent/data-schema-core';
import { arrayify } from "../../lib/utils/array";
import { processPropsSchema } from "../../lib/utils/dataSchema/processPropsSchema";
import { identity } from "lodash-es";
export function getCompletedAtom(atom) {
  return new CompletedAtom(atom);
}
export class CompletedAtom {
  constructor(rawAtom) {
    var _rawAtom$visible;
    this.rawAtom = rawAtom;
    this.id = rawAtom.id;
    this.name = rawAtom.name;
    this.desc = rawAtom.desc || '';
    this.icon = rawAtom.icon || ''; // TODO: 默认图标
    this.category = rawAtom.category || '未分类';
    this.visible = (_rawAtom$visible = rawAtom.visible) !== null && _rawAtom$visible !== void 0 ? _rawAtom$visible : true;
    this.hideReturnValueSchema = !!rawAtom.hideReturnValueSchema;
    let rawReturnValue = rawAtom.returnValue;
    if (rawReturnValue) {
      if (typeof rawReturnValue === 'string') {
        rawReturnValue = {
          type: 'any',
          description: rawReturnValue
        };
      }
      if (typeof rawReturnValue === 'object') {
        this.returnValue = identity.bind(null, getPatchedDataSchema(rawReturnValue));
      } else if (typeof rawReturnValue === 'function') {
        this.returnValue = (params, ...args) => {
          try {
            const val = rawReturnValue({
              ...this.defaultParams,
              ...params
            }, ...args);
            if (typeof val !== 'object') return null;
            return val;
          } catch (err) {
            console.error(`[UICore] 行为原子 ${this.id} 的 returnValue 存在逻辑错误`, err);
          }
        };
      }
    }
    this.handleCollectDeps = rawAtom.handleCollectDeps;
    this.paramsFormComponents = rawAtom.paramsFormComponents;
    const tmp = processPropsSchema(rawAtom.paramsSchema);
    this.defaultParams = tmp.defaultValue;
    this.allowInteropParams = tmp.allowInteropFields;
    this.paramsSchema = tmp.newDataSchema;
  }
  /**
   * （编辑模式）校验这个步骤原子的参数是否有问题，仅限编辑模式做快速校验的
   *
   * @param params 用户给步骤配置的参数（可以是不完整的，这里会使用 defaultParams 补全）
   * @param ctxExtra
   * @returns 如果有错误，返回错误信息，可以是多条
   */
  validateParams(ctxBase, params) {
    const validate = this.rawAtom.validateParams;
    if (typeof validate !== 'function') return null;
    // eslint-disable-next-line @typescript-eslint/ban-types
    let ans;
    try {
      ans = validate(ctxBase, {
        ...this.defaultParams,
        ...params
      });
    } catch (err) {
      if ('message' in err) ans = err.message;
    }
    if (ans && ans.length !== 0) return arrayify(ans);
    return null;
  }
  /**
   * 步骤原子的具体执行过程
   *
   * 注意，如果要注入一些临时变量啥的，请不要直接挂在 `ctx` 上。请挂在 `ctx.state`
   *
   * @param ctx 执行上下文
   * @param params 用户给步骤配置的参数（必须是完整 + 补全过的）
   *
   * @returns 一般是一个 Promise，也可以为普通的同步函数
   */
  execute(ctx, params) {
    return this.rawAtom.execute(ctx, params, ctx.args);
  }
  /**
   * （编辑模式）根据当前的参数生成说明文字
   */
  getDisplayName(step) {
    var _this$rawAtom$getDisp, _this$rawAtom;
    return (_this$rawAtom$getDisp = (_this$rawAtom = this.rawAtom).getDisplayName) === null || _this$rawAtom$getDisp === void 0 ? void 0 : _this$rawAtom$getDisp.call(_this$rawAtom, step);
  }
  /** （编辑模式）在事件面板title显示一些东西 */
  getEventPanelSubTitle(step) {
    var _this$rawAtom$getEven, _this$rawAtom2;
    return (_this$rawAtom$getEven = (_this$rawAtom2 = this.rawAtom).getEventPanelSubTitle) === null || _this$rawAtom$getEven === void 0 ? void 0 : _this$rawAtom$getEven.call(_this$rawAtom2, step);
  }
}